import React from "react";
import { useNavigate } from "react-router-dom";
import PageContainer from "../../components/page-container";
import s from "./styles.module.scss";
import { ReactComponent as CheckmarkIcon } from "../../assets/Checkmark_in_circle.svg";
import Button from "../../components/button";

const WaitlistSuccess = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <div className={s.successIcon}>
        <CheckmarkIcon width="48" height="48" />
      </div>

      <h2 className={s.welcomeTitle}>You're on the waitlist!</h2>

      <p className={s.authPrompt}>
        Thank you for your interest. We've added you to our waitlist and will
        notify you by email when your access is approved.
      </p>

      <div className={s.successDetails}>
        <h3>What happens next?</h3>
        <ul>
          <li>You'll receive a confirmation email shortly</li>
          <li>Our team will review your request</li>
          <li>We'll email you when your account is approved</li>
          <li>You can then sign in and start using the platform</li>
        </ul>
      </div>

      <Button variant="primary" size="medium" onClick={() => navigate("/")}>
        Back to Home
      </Button>
    </PageContainer>
  );
};

export default WaitlistSuccess;
